export default __webpack_public_path__ + "static/media/my_notifications_icon_active_old.7231f6cb.svg";